import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, catchError, of, switchMap, throwError } from 'rxjs';
import { Injectable } from '@angular/core';
import { PairingService } from '../services/pairing.service';
import { RelationType } from '../enums/relation-type';

@Injectable({
  providedIn: 'root',
})
export class PatientDetailsGuard implements CanActivate {
  constructor(private pairingService: PairingService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (!route.params['uuid']) {
      return false;
    }

    return this.pairingService.getMyPatients().pipe(
      switchMap((res) => {
        const index = res.findIndex(
          (patient) =>
            patient.pairing.relationType == RelationType.ACCEPTED &&
            (patient.pairing.sourceUserId == route.params['uuid'] ||
              patient.pairing.targetUserId == route.params['uuid'])
        );

        if (index < 0) {
          return throwError(() => new Error('Not accepted pairing'));
        }

        return of(true);
      }),
      catchError((error) => {
        this.router.navigate(['/']);
        return of(false);
      })
    );
  }
}
